// extracted by mini-css-extract-plugin
export default {"container":"ArticleLink_container__O6urq","Main":"ArticleLink_Main__jJUQy","MastheadText":"ArticleLink_MastheadText__gkOOd","Background":"ArticleLink_Background__wS+wc"};